// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class TransactionAPI extends MainAPI {
	/**
	 * @params queryParams
	 * */
	async getCustomerOrderList(queryParams) {
		return API.get(`${ENDPOINTS.GET_ORDER_LIST}?${queryString.stringify(queryParams)}`)
	}

	/**
	 * @return {object} order data
	 * @param orderId
	 */
	async getTransactionOrderById(orderId) {
		return API.get(`${ENDPOINTS.GET_ORDER}/${orderId}`);
	}

	/**
	 * 
	 * @param {Integer} orderId 
	 * @returns 
	 */
	async getTransactionDogOrderById(orderId) {
		return API.get(`${ENDPOINTS.GET_CUSTOMER_DOG_ORDER}/${orderId}`);
	}

	/**
	 * 
	 * @param {String} queryParams 
	 * @returns 
	 */
	async getCustomerDogOrderHistoryList(queryParams) {
		return API.get(`${ENDPOINTS.GET_CUSTOMER_DOG_ORDER_LIST}?${queryString.stringify(queryParams)}`)
	}
	
	/**
	 * @return No content
	 * @param orderId
	 * @param petId
	 * @param body - reason
	 */
	async putCancelOrder(orderId, petId, body) {
		return API.put(`${ENDPOINTS.PUT_ORDER}/${orderId}/cancel/${petId}`, body);
	}

	/**
	 * 
	 * @param {Integer} orderId 
	 * @param {Object} body 
	 * @returns 
	 */
	async putCancelDogOrder(orderId, body) {
		return API.put(`${ENDPOINTS.PUT_ORDER}/${orderId}/request-refund`, body);
	}

	/**
	 * @return {Object} Count
	 * @param petId
	 */
	async getPendingOrdersCount(petId) {
		return API.get(`${ENDPOINTS.GET_ORDER}/pending/${petId}`);
	}

	/**
	 * @return {Object} Count
	 */
	async getPendingDogOrdersCount() {
		return API.get(`${ENDPOINTS.GET_CUSTOMER_DOG_ORDER}/pending`);
	}

	/**
	 * @param orderId
	 * @return No content
	 */
	async updateProductOrderStatus(orderId, body) {
		return API.put(`${ENDPOINTS.PUT_ORDER}/${orderId}/update-order-status`, body);
	}

	/**
	 * @params queryParams
	 * */
	async getCustomerSubscriptionList(queryParams) {
		return API.get(`${ENDPOINTS.GET_SUBSCRIPTION_LIST}?${queryString.stringify(queryParams)}`)
	}
}


export default new TransactionAPI();
